
import basePerimeter from '@/permissions/basePerimeter.js';
import accountPerimeter from '@/permissions/accountPerimeter.js';

function load (component) {
    // '@' is aliased to src/components
    return () => import(`page/${component}.vue`)
}
function partial (component) {
    // '@' is aliased to src/components
    return () => import(`component/${component}.vue`)
}


// DEFINE CUSTOM ROUTES
const routes = [
    // router.js
    {
        path: '/sign/:token',
        name: 'SignPage',
        component: load('sign/index'),
        meta: {
            auth: false,
            paywall: false,
            menu: false,
        },
    },
    {
        name: "dashboard",
        path: "/",
        component: load('planning/calendar'),
        meta: {
            auth: true,
            paywall: true,
            perimeter: basePerimeter,
            perimeterAction: 'accessCalendar',
        },
        children : [

            {
                name: "shift",
                path: "shift",
                component: partial('calendar/popup-shift'),
                meta: {
                    auth: true,
                },
            },
        ]
    },
    {
        name: "login",
        path: "/user/login",
        component: load('user/login'),
        meta: {
            auth: false,
            menu: false,
            profile: false,
            transition: 'auth'
        },
    },

    {
        name: "register",
        path: "/user/register",
        component: load('user/register'),
        meta: {
            auth: false,
            profile: false,
        },
    },
    {
        name: "registercompany",
        path: "/company/register",
        component: load('user/register'),
        meta: {
            auth: false,
            profile: false,
        },
    },


    {
        name: "introduction",
        path: "/user/introduction",
        component: load('user/introduction'),
        meta: {
            auth: false,
            menu: false,
        },
    },
    {
        name: "payment",
        path: "/payment",
        component: load('payment'),
        meta: {
            auth: true,
            menu: false, 
            //perimeter: basePerimeter,
            windowTitle: 'payment',
        },
    },
    {
        name: "forgotpassword",
        path: "/user/forgotpassword",
        component: load('user/forgotpassword'),
        meta: {
            auth: false,
            menu: false,
            transition: 'auth'
        },
    },
    {
        name: "changepassword",
        path: "/password/reset/:token",
        component: load('user/changepassword'),
        props: { default: true },
        meta: {
            auth: false,
            menu: false,
            transition: 'auth'
        },
    },
    {
        name: "activate",
        path: "/activate/:id",
        component: load('user/activate'),
        meta: {
            auth: false,
            menu: false,
            profile: false,
        },
    },
    {
        name: "users",
        path: "/users",
        component: load('management/useroverview'),
        meta: {
            auth: true,
            perimeter: basePerimeter,
            perimeterAction: 'accessUsers',
        },
    },

    {
        name: "companies",
        path: "/companies",
        component: load('management/companyoverview'),
        meta: {
            auth: true,
            perimeter: basePerimeter,
            perimeterAction: 'accessCompanies',
        },
    },
    {
        path: "/company/:id/",
        component: load('company/index'),
        meta: {
            auth: true,
            perimeter: basePerimeter,
            perimeterAction: 'accessCompanies',
        },
        children: [
            {
                name: "companyDetail",
                path: "",
                component: load('company/detail'),
                meta: {
                    auth: true,
                    windowTitle: 'detail',
                    perimeter: basePerimeter,
                    perimeterAction: 'accessCompanies',
                },
            },
            {
                name: "company",
                path: "departments",
                component: load('company/departments'),
                meta: {
                    auth: true,
                    windowTitle: 'departments',
                },
            },
            {
                name: "agreements",
                path: "agreements",
                component: load('company/agreements'),
                meta: {
                    auth: true,
                    windowTitle: 'agreements',
                },
            },
            {
                name: "import",
                path: "import",
                component: load('company/import'),
                meta: {
                    auth: true,
                    windowTitle: 'import',
                    
                },
            },
           
            {  
                name: "comdashboard",
                path: "dashboard",
                component: load('company/dashboard'),
                meta: {
                    auth: true,
                    windowTitle: 'dashboard',
                },
            },
            {
                name: "departmentedit",
                path: "department/:departmentid",
                component: load('company/department'),
                meta: {
                    auth: true,
                    windowTitle: 'departments',
                },
            },
            {
                name: "importView",
                path: "import/:importId",
                component: load('company/import_details'),
                meta: {
                    auth: true,
                    windowTitle: 'import_details',
                },
            },
            {
                name: "departmentcreate",
                path: "department",
                component: load('company/department'),
                meta: {
                    auth: true,
                    windowTitle: 'departments',
                },
            },
            {
                name: "companyinvoices",
                path: "invoices",
                component: load('invoices'),
                meta: {
                    auth: true,
                    windowTitle: 'invoices',
                },
            },
            {
                name: "companyworkorders",
                path: "workorders",
                component: load('workorders'),
                meta: {
                    auth: true,
                    windowTitle: 'workorders',
                },
            },
            {
                name: "companyworkorder",
                path: "workorder/:workorderid",
                component: load('workorderdetail'),
                meta: {
                    auth: true,
                    windowTitle: 'workorders',
                    showTab: false,
                },
            }
        ]
    },
    {
        path: "/profile/",
        component: load("user/index"),
        meta: {
            auth: true,
            //paywall: true, // This must be non-paywalled to edit profile
        },
        children: [
            {
                name: "user",
                path: "",
                component: load('user/detail'),
                meta: {
                    auth: true,
                    //paywall: true, // This must be non-paywalled to edit profile
                    windowTitle: 'personaldata',
                },
            },
            {
                name: "useredit",
                path: "edit",
                component: load('user/profile'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'personaldata',
                },
            },
            {
                name: "usercreate",
                path: "create",
                component: load('user/register'),
                meta: {
                    auth: true,
                    windowTitle: 'personaldata',
                    showTab: false,
                },
            },
            {
                name: "userinvoices",
                path: "invoices",
                component: load('invoices'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'invoices',
                    perimeter: accountPerimeter,
                    perimeterAction: 'accessInvoices',
                },
            },
            {
                name: "userworkorders",
                path: "workorders",
                component: load('workorders'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'workorders',
                },
            },
            {
                name: "useragreements",
                path: "agreements",
                component: load('agreements'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'agreements',
                },
            },
            {
                name: "userworkorder",
                path: "workorder/:workorderid",
                component: load('workorderdetail'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'workorders',
                    showTab: false,
                },
            },
            {
                name: "userdashboard",
                path: "dashboard",
                component: load('user/userdashboard'),
                meta: {
                    auth: true,
                    paywall: true,
                    windowTitle: 'dashboard',
                },
            },
            {  
                name: "oeps",
                path: "oeps",
                component: load('user/oeps'),
                meta: {
                    auth: false,
                    windowTitle: 'oeps',
                },
            },
            {
                name: "usersubscriptions",
                path: "subscriptions",
                component: load('subscriptions'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'subscriptions',
                },
            },
            {
                name: "usersubscription",
                path: "subscription/:subscriptionid",
                component: load('subscriptiondetail'),
                meta: {
                    auth: true,
                    windowTitle: 'subscriptions',
                    showTab: false,
                },
            },
            {
                name: "userworkorderautograph",
                path: "workorder/:workorderid/autograph/:type",
                component: load('autograph'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'workorders autograph',
                    showTab: false,
                },
            },
        ]
    },
    {
        path: "/profile/:id/",
        component: load("user/index"),
        meta: {
            auth: true,
            //paywall: true,
        },
        children: [
            {
                name: "userid",
                path: "",
                component: load('user/detail'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'personaldata',
                },
            },
            {
                name: "usereditid",
                path: "edit",
                component: load('user/profile'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'personaldata',
                },
            },
            {
                name: "userinvoicesid",
                path: "invoices",
                component: load('invoices'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'invoices',
                },
            },
            {
                name: "userworkordersid",
                path: "workorders",
                component: load('workorders'),
                meta: {
                    auth: true,
                    //paywall: true,
                    windowTitle: 'workorders',
                },
            },
            {
                name: "useragreementsid",
                path: "agreements",
                component: load('agreements'),
                meta: {
                    auth: true,
                    windowTitle: 'agreements',
                },
            },
            {
                name: "userworkorderid",
                path: "workorder/:workorderid",
                component: load('workorderdetail'),
                meta: {
                    auth: true,
                    windowTitle: 'workorders',
                    showTab: false,
                },
            },
            {
                name: "userdashboardid",
                path: "signals",
                component: load('user/userdashboard'),
                meta: {
                    auth: true,
                    windowTitle: 'userdashboard',
                },
            },
            {
                name: "usersubscriptionsid",
                path: "subscriptions",
                component: load('subscriptions'),
                meta: {
                    auth: true,
                    windowTitle: 'subscriptions',
                },
            },
            {
                name: "usersubscriptionid",
                path: "subscriptions/:subscriptionsid",
                component: load('subscriptionsdetail'),
                meta: {
                    auth: true,
                    windowTitle: 'subscriptions',
                    showTab: false,
                },
            }
        ]
    },
    {
        path: "/premium",
        component: load("premium/index"),
        meta: {
            auth: true,
        },
        children: [
            {
                name: "premium",
                path: "",
                component: load('premium/getpremium'),
                meta: {
                    auth: true,
                    windowTitle: 'Premium abonnement',
                },
            },
            {
                name: "forecast",
                path: "/forecast",
                component: load('premium/forecast'),
                meta: {
                    auth: true,
                    windowTitle: 'forecast',
                    perimeter: basePerimeter,
                    perimeterAction: 'isPremium',
                },
            },
            {
                name: "reports",
                path: "/reports",
                component: load('premium/reports'),
                meta: {
                    auth: true,
                    windowTitle: 'reports',
                    perimeter: basePerimeter,
                    perimeterAction: 'isPremium',
                },
            },
        ]
    },
    {
        name: "notfound",
        path: "*",
        component: load('notfound')
    },
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes/routes.js